import { Injectable } from "@angular/core";
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LazyLoaderService {
  private  showLoader$ :  Subject<unknown>;
  public isLoading = new Subject<boolean>();

  constructor() {
    this.showLoader$ = new Subject<unknown>();
  }

  show(module: string) {
    this.showLoader$.next({module: module, loading:true});
  }

  hide(module: string) {
    this.showLoader$.next({module: module, loading:false});
  }

  getLoader() {
    return this.showLoader$;
  }

  showLoader() {
    this.isLoading.next(true);
  }

  hideLoader() {
    this.isLoading.next(false);
  }
}
